<span class="hypometer-widget content-banner betting-action">
	<div elevation="5" class="card rounded-lg">
		<div class="row" justify="center" align="stretch">
			<div cols="12" md="3" class="col pa-0 cutoff">
				<div class="banner-image-d d-md-flex d-none">
					<img loading="lazy" [src]="desktopImageURL" [alt]="desktopImageAltText">
				</div>
				<div class="banner-image-m d-sm-flex d-md-none">
					<img loading="lazy" [src]="mobileImageURL" [alt]="mobileImageAltText">
				</div>
			</div>
			<div cols="12" md="6" justify="center" align="center" class="col banner-content-checklist">
				<div class="d-md-flex banner-content align-center">
					<div class="content-desc">
						<p
							style="font-weight: 700; line-height: 1; font-size: 24px; text-align: center;"
							[innerHTML]="betString"
						></p>
						<p class="content-odds"
							*ngIf="oddsString"
							style="margin-top: 10px;"
							[style.color]="oddsTextColour ? '#' + oddsTextColour : null"
							[innerHTML]="oddsString"
						>
						</p>
					</div>
				</div>
			</div>
			<div cols="12" md="3" justify="center" align="center" class="col">
				<div class="cta">
					<a class="btn no-text-transform" id="bookie-button"
						[style.color]="buttonTextColour ? '#' + buttonTextColour : 'initial'"
						[style.font-weight]="700"
						[style.background-color]="buttonBackgroundColour ? '#' + buttonBackgroundColour : 'initial'"
						[style.height]="'initial'"
						[href]="destination"
						target="_blank"
						[attr.data-recording-click-props]="clickProps"
						x-large
					>
						<span class="desktop-only" [innerHTML]="desktopButtonString"></span>
						<span class="mobile-only" [innerHTML]="mobileButtonString"></span>
					</a>

				</div>
			</div>
		</div>
	</div>
</span>